
import { addLayerExist, removerLayerExist } from '../layerStatusControl'
/**
 * 基于czml格式 添加属性
 */
var czmlData = {}
var czmlDataSource = {}

function addSatInfoCZMLLayer (layerInfo, viewer) {
  // 此处使用 原有解析
  const _id = layerInfo.id
  const info = layerInfo.data
  const czmlInfo = convertData2CZML(info)

  const dataSourcePromise = Cesium.CzmlDataSource.load(czmlInfo)
  viewer.dataSources.add(dataSourcePromise)
  dataSourcePromise
    .then(function (dataSource) {
      czmlDataSource[_id] = dataSource
      czmlData[_id] = layerInfo.data
    })
    .otherwise(function (error) {
      console.log(error)
    })
  const addInfo = {
    info: layerInfo,
    layer: null,
    market: dataSourcePromise
  }
  addLayerExist(addInfo)
  return true
}

function removeSatInfoCZMLLayer (layerInfo, viewer) {
  const _id = layerInfo.id
  const _czmlDataSource = czmlDataSource[_id]
  if (_czmlDataSource) {
    viewer.dataSources.remove(_czmlDataSource)
    czmlDataSource[_id] = null
    removerLayerExist(layerInfo)
  }
}

function convertData2CZML (data) {
  const initCZML = [{
    id: 'document',
    name: 'CZML Point',
    version: '1.0'
  }]

  const satDataList = data
  // 样式
  const _style = satDataList.style

  const _info = satDataList.data
  // 线
  const lineList = _info.lineList || []
  lineList.forEach((line, index) => {
    const lineCzml = convertLine2CZML(line, index, _style)
    initCZML.push(lineCzml)
  })
  // 点
  const pointList = _info.pointList || []
  pointList.forEach((point, index) => {
    const pointCzml = convertPoint2CZML(point, index, _style)
    initCZML.push(pointCzml)
  })

  return initCZML
}

const defaultLineStyle = {
  lineColor: [0, 0, 255, 255],
  outlineColor: [0, 0, 255, 255],
  outlineWidth: 2,
  lineWidth: 2
}

function convertLine2CZML (line, index, style) {
  const styleName = line.style
  const lineStlye = style[styleName] || defaultLineStyle

  const positions = line.position
  const _height = line.height
  const pointList = []
  for (let i = 0; i < positions.length; i++) {
    const point = positions[i]
    //   pointList.push(i * 10)
    pointList.push(parseFloat(point[0]))
    pointList.push(parseFloat(point[1]))
    pointList.push(_height)
  }
  // const title = point.title
  const lineCZML = {
    id: 'path ' + index,
    name: 'path ' + index,
    polyline: {
      positions: {
        cartographicDegrees: pointList
      },
      material: {
        polylineOutline: {
          color: {
            rgba: lineStlye.lineColor || defaultLineStyle.lineColor
          },
          outlineColor: {
            rgba: lineStlye.outlineColor || defaultLineStyle.outlineColor
          },
          outlineWidth: lineStlye.outlineWidth || defaultLineStyle.outlineWidth
        }
      },
      width: lineStlye.lineWidth || defaultLineStyle.lineWidth
    }
  }
  return lineCZML
}

const defaultPointColor = {
  // label 字体颜色
  labelFillColor: [255, 255, 255, 255],
  // label 填充颜色
  labelBackgroundColor: [0, 0, 0, 0],
  // 点颜色
  pointColor: [255, 255, 255, 255],
  // 点宽度
  pixelSize: 2,
  // 点边缘颜色
  outlineColor: [255, 255, 255, 255],
  // 点边缘宽度
  outlineWidth: 2
}

function convertPoint2CZML (point, i, style) {
  const styleName = point.style
  const coodInfo = point.position
  const _height = point.height
  const title = point.title
  const stlyeInfo = style[styleName] || defaultPointColor
  const info = {
    id: 'point ' + i,
    name: 'point ' + i,
    position: {
      cartographicDegrees: [coodInfo[0], coodInfo[1], _height]
    },
    label: {
      fillColor: {
        rgba: stlyeInfo.labelFillColor || defaultPointColor.labelFillColor
      },
      font: '8pt Lucida Console',
      horizontalOrigin: 'LEFT',
      pixelOffset: {
        cartesian2: [8, 0]
      },
      style: 'FILL',
      text: title,
      showBackground: true,
      backgroundColor: {
        rgba: stlyeInfo.labelBackgroundColor || defaultPointColor.labelBackgroundColor
      }
    },
    point: {
      color: {
        rgba: stlyeInfo.pointColor || defaultPointColor.pointColor
      },
      outlineColor: {
        rgba: stlyeInfo.outlineColor || defaultPointColor.outlineColor
      },
      outlineWidth: stlyeInfo.outlineWidth || defaultPointColor.outlineWidth,
      pixelSize: stlyeInfo.pixelSiz || defaultPointColor.pixelSize
    }
  }
  return info
}

export { addSatInfoCZMLLayer, removeSatInfoCZMLLayer }
